var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCtVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 2.5H18.1667C18.3877 2.5 18.5996 2.5878 18.7559 2.74408C18.9122 2.90036 19 3.11232 19 3.33333V16.6667C19 16.8877 18.9122 17.0996 18.7559 17.2559C18.5996 17.4122 18.3877 17.5 18.1667 17.5H1.83333C1.61232 17.5 1.40036 17.4122 1.24408 17.2559C1.0878 17.0996 1 16.8877 1 16.6667V3.33333C1 3.11232 1.0878 2.90036 1.24408 2.74408C1.40036 2.5878 1.61232 2.5 1.83333 2.5ZM2.66667 4.16667V15.8333H17.3333V4.16667H2.66667Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06422 11.43C8.88422 11.92 8.52422 12.56 7.51422 12.56C6.09422 12.56 5.61422 11.26 5.61422 10.03C5.61422 8.72 6.14422 7.52 7.47422 7.52C8.46422 7.52 8.88422 8.06 9.06422 8.67H10.3642C10.1742 7.51 9.28422 6.48 7.52422 6.48C5.33422 6.48 4.27422 8.18 4.27422 10.07C4.27422 12.04 5.31422 13.59 7.46422 13.59C9.13422 13.59 10.0742 12.68 10.3642 11.43H9.06422ZM12.6845 13.5H13.9845V7.66H16.1245V6.58H10.5445V7.66H12.6845V13.5Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCtVolume);
export default __webpack_public_path__ + "static/media/icon-CT-Volume.581e3199.svg";
export { ForwardRef as ReactComponent };